module.exports = __webpack_public_path__ + "static/media/img132_R.d01e1ffc.jpg";